// Delay execution
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* Sticky navigation on scroll */
(function () {
  const navigation = document.getElementById("gh-navigation");
  if (!navigation) return;

  let lastScrollY = window.scrollY;

  window.addEventListener(
    "scroll",
    function () {
      const currentScrollY = window.scrollY;

      // Add is-scrolled class when user has scrolled down
      if (currentScrollY > 10) {
        navigation.classList.add("is-scrolled");
      } else {
        navigation.classList.remove("is-scrolled");
      }

      lastScrollY = currentScrollY;
    },
    { passive: true }
  );
})();

/* Desktop submenu toggle (hover and click) */
(function () {
  const submenuToggle = document.querySelector(".gh-sub-menu-toggle");
  const submenu = document.querySelector(".nav-sub-menu");

  if (!submenuToggle || !submenu) return;

  // Handle click toggle
  submenuToggle.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const isExpanded = submenuToggle.getAttribute("aria-expanded") === "true";

    // Toggle the state
    submenuToggle.setAttribute("aria-expanded", !isExpanded);
    submenu.setAttribute("aria-hidden", isExpanded);
    submenu.classList.toggle("is-open", !isExpanded);
  });

  // Close submenu when clicking outside
  document.addEventListener("click", function (e) {
    if (!submenu.contains(e.target) && !submenuToggle.contains(e.target)) {
      submenuToggle.setAttribute("aria-expanded", "false");
      submenu.setAttribute("aria-hidden", "true");
      submenu.classList.remove("is-open");
    }
  });

  // Handle keyboard navigation
  submenuToggle.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      submenuToggle.setAttribute("aria-expanded", "false");
      submenu.setAttribute("aria-hidden", "true");
      submenu.classList.remove("is-open");
      submenuToggle.focus();
    }
  });
})();

/* Mobile menu flyout toggle */
(function () {
  const navigation = document.querySelector(".gh-navigation");
  const burger = navigation.querySelector(".gh-burger");
  const flyoutMenu = navigation.querySelector(".gh-flyout-menu");
  const flyoutClose = navigation.querySelector(".gh-flyout-close");
  const flyoutBack = navigation.querySelector(".gh-flyout-back");
  const flyoutPrimary = navigation.querySelector(".gh-flyout-primary");
  const flyoutSubmenu = navigation.querySelector(".gh-flyout-submenu");
  const flyoutSubmenuItems = navigation.querySelector(
    ".gh-flyout-submenu-items"
  );

  if (!burger || !flyoutMenu) return;

  // Open menu
  const openMenu = function () {
    navigation.classList.add("is-open");
    flyoutMenu.classList.add("is-open");
    flyoutMenu.setAttribute("aria-hidden", "false");

    // Prevent body scroll
    document.documentElement.style.overflowY = "hidden";

    // Show primary menu, hide submenu
    if (flyoutPrimary) flyoutPrimary.setAttribute("aria-hidden", "false");
    if (flyoutSubmenu) flyoutSubmenu.setAttribute("aria-hidden", "true");
  };

  // Wait until the flyout has visually dissappeared and then update the aria-attribute and re-enable the burger
  async function FlyoutHide() {
    await delay(200);
    flyoutMenu.setAttribute("aria-hidden", "true");
    burger.disabled = false;
  }

  // Close menu
  const closeMenu = function () {
    navigation.classList.remove("is-open");
    flyoutMenu.classList.remove("is-open");

    // Disable burger to prevent attempts to reopen to quickly
    console.log(burger);
    burger.disabled = true;
    FlyoutHide();

    // Restore body scroll
    document.documentElement.style.overflowY = null;
  };

  // Handle submenu items with children
  const setupSubmenuItems = function () {
    if (!flyoutPrimary) return;

    const menuItems = flyoutPrimary.querySelectorAll("li");
    menuItems.forEach(function (item) {
      const button = item.querySelector("button");
      const submenu = item.querySelector("ul");

      if (submenu && button) {
        // Mark as having submenu
        item.classList.add("has-submenu");

        // Prevent default navigation
        button.addEventListener("click", function (e) {
          e.preventDefault();

          console.log("SUBMENU");

          // Populate submenu
          if (flyoutSubmenuItems) {
            console.log("CLEAR EXISTING");
            flyoutSubmenuItems.innerHTML = "";
            const submenuItems = submenu.querySelectorAll("li");
            console.log("GET NEW");
            console.log(submenuItems);

            // Add submenu items
            submenuItems.forEach(function (subItem) {
              console.log("A");
              const subLink = subItem.querySelector("a").cloneNode(true);
              if (subLink) {
                console.log("B");
                const wrapper = document.createElement("li");
                wrapper.className = "gh-flyout-submenu-item";

                subLink.addEventListener("click", function () {
                  closeMenu();
                });

                // const newLink = document.createElement("a");
                // newLink.href = subLink.href;
                // newLink.textContent = subLink.textContent;
                // newLink.addEventListener("click", function () {
                //   closeMenu();
                // });

                // wrapper.appendChild(newLink);
                wrapper.appendChild(subLink);
                console.log("C");
                flyoutSubmenuItems.appendChild(wrapper);
                console.log("D");
              }
            });
          }

          // Show submenu, hide primary
          if (flyoutPrimary) flyoutPrimary.setAttribute("aria-hidden", "true");
          if (flyoutSubmenu) flyoutSubmenu.setAttribute("aria-hidden", "false");
        });
      }
    });
  };

  // Back button handler
  if (flyoutBack) {
    flyoutBack.addEventListener("click", function () {
      // Show primary menu, hide submenu
      if (flyoutPrimary) flyoutPrimary.setAttribute("aria-hidden", "false");
      if (flyoutSubmenu) flyoutSubmenu.setAttribute("aria-hidden", "true");
    });
  }

  // Event listeners
  burger.addEventListener("click", openMenu);
  flyoutClose.addEventListener("click", closeMenu);
  // overlay.addEventListener("click", closeMenu);

  // Setup submenu items
  setupSubmenuItems();

  // Handle window resize
  window.addEventListener("resize", function () {
    if (window.innerWidth > 768) {
      closeMenu();
    }
  });
})();

/* Add lightbox to gallery images */
(function () {
  lightbox(
    ".kg-image-card > .kg-image[width][height], .kg-gallery-image > img"
  );
})();

/* Responsive video in post content */
(function () {
  const sources = [
    '.gh-content iframe[src*="youtube.com"]',
    '.gh-content iframe[src*="youtube-nocookie.com"]',
    '.gh-content iframe[src*="player.vimeo.com"]',
    '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
    ".gh-content object",
    ".gh-content embed"
  ];
  reframe(document.querySelectorAll(sources.join(",")));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
// (function () {
//     dropdown();
// })();

/* Infinite scroll pagination */
// (function () {
//   if (
//     !document.body.classList.contains("home-template") &&
//     !document.body.classList.contains("post-template")
//   ) {
//     pagination();
//   }
// })();

/* Responsive HTML table */
(function () {
  const tables = document.querySelectorAll(
    ".gh-content > table:not(.gist table)"
  );

  tables.forEach(function (table) {
    const wrapper = document.createElement("div");
    wrapper.className = "gh-table";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();

/* Resource sidebar toggle */
(function () {
  const sidebarToggle = document.querySelector(
    ".resource-layout__sidebar-toggle"
  );
  const sidebar = document.querySelector(".resource-layout__sidebar");

  if (!sidebarToggle || !sidebar) return;

  sidebarToggle.addEventListener("click", function () {
    const isExpanded = sidebarToggle.getAttribute("aria-expanded") === "true";

    // Toggle a fixed height of the sidebar
    sidebar.style.height = isExpanded ? `${sidebar.offsetHeight}px` : "auto";

    // Toggle the collapsed state
    sidebar.classList.toggle("is-collapsed");
    sidebarToggle.setAttribute("aria-expanded", !isExpanded);
  });
})();

/* Member dropdown toggle */
(function () {
  const memberToggle = document.querySelector(".gh-member-dropdown-toggle");
  const memberMenu = document.querySelector(".nav-member-dropdown");

  if (!memberToggle) return;

  memberToggle.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const isExpanded = memberToggle.getAttribute("aria-expanded") === "true";
    memberToggle.setAttribute("aria-expanded", !isExpanded);
    memberMenu.setAttribute("aria-hidden", isExpanded);
  });

  document.addEventListener("click", function (e) {
    if (!memberToggle.contains(e.target)) {
      memberToggle.setAttribute("aria-expanded", "false");
      memberMenu.setAttribute("aria-hidden", "true");
    }
  });
})();

/* FAQ toggle */
(function () {
  const faqToggle = document.querySelectorAll(".kg-toggle-card");

  if (!faqToggle) return;

  faqToggle.forEach((element) => {
    console.log("A");
    element.addEventListener("click", function (e) {
      console.log("B");
      e.preventDefault();
      e.stopPropagation();
      console.log("C");
      console.log(element.getAttribute("data-kg-toggle-state"));
      let status = element.getAttribute("data-kg-toggle-state");
      element.setAttribute(
        "data-kg-toggle-state",
        status == "open" ? "close" : "open"
      );
    });
  });
})();
